var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"error-modal","hide-header":"","ok-only":"","ok-variant":"danger"}},[_c('p',{staticClass:"my-4"},[_vm._v("There was a problem processing your request. Please try again. We apologize for the inconvenience! ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }